import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { API_URL, LIVE } from '../../common/variables';

const getCurrentPlan = createAsyncThunk(
  'GET_PLAN',
  async (id, { getState, rejectWithValue }) => {
    try {
      const { token } = getState().app;
      let res = await fetch(API_URL + '/subscriptions/current', {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.status === 200) {
        let result = await res.json();
        return result;
      } else return rejectWithValue(res.status);
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

const createPaymentIntent = createAsyncThunk(
  'CREATE_PAYMENT_INTENT',
  async (id, { getState, rejectWithValue }) => {
    try {
      const { token } = getState().app;
      let res = await fetch(API_URL + '/subscriptions/checkout', {
        method: 'POST',
        body: JSON.stringify({
          planId: id,
        }),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.status === 200) {
        let result = await res.json();
        return result;
      } else return rejectWithValue(res.status);
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

const currentPlan = createSlice({
  name: 'plan',
  initialState: {
    isFetchingCurrentPlan: false,
    errorFetchingCurrentPlan: false,
    currentPlan: {},
    isCreatingPaymentIntent: false,
    errorCreatingPaymentIntent: false
  },
  reducers: {},
  extraReducers: {
    [getCurrentPlan.pending]: (state) => {
      state.isFetchingCurrentPlan = true;
    },
    [getCurrentPlan.fulfilled]: (state, action) => {
      state.isFetchingCurrentPlan = false;
      state.errorFetchingCurrentPlan = false;
      state.plan = action.payload;
    },
    [getCurrentPlan.rejected]: (state, action) => {
      state.errorFetchingCurrentPlan = true;
    },
    [createPaymentIntent.pending]: (state) => {
      state.isCreatingPaymentIntent = true;
    },
    [createPaymentIntent.fulfilled]: (state, action) => {
      state.isCreatingPaymentIntent = false;
      state.errorCreatingPaymentIntent = false;
    },
    [createPaymentIntent.rejected]: (state, action) => {
      state.errorCreatingPaymentIntent = true;
    },
  },
});

export { getCurrentPlan, createPaymentIntent };
export default currentPlan.reducer;
